import { fistSvg } from "@/assets/images/svgFiles";
import { sharedStyles } from "@lib/sharedStyles";
import { LitElement, TemplateResult, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement("game-points-component")
export class GamePointsComponent extends LitElement {
	static readonly styles = [
		sharedStyles,
		css`
			.container {
				border: var(--border-default);
				border-radius: var(--border-radius);
				background: white;
				box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
			}

			.container-top {
				display: flex;
				align-items: center;
				width: 100%;
				height: 90px;
			}

			.score-text-container {
				display: flex;
				align-items: center;
				justify-content: center;
				flex: 1;
				border-right: 3px solid black;
				background-color: var(--color-pink);
				height: 100%;
			}

			.points-text {
				font-size: 3.4em;
			}
			
			.game-name-container {
				display: flex;
				align-items: center;
				justify-content: center;
				flex: 1;
				height: 100%;    
				padding: 8px;
			}

			.divider {
				width: 100%;
				height: 3px;
				background-color: #000000;
			}

			.container-bottom {
				display: flex;
				flex-direction: column;
				width: 100%;
				border-radius: var(--border-radius);
			}

			.content-section {
				width: 100%;
				display: flex;
				flex-direction: column;
				align-items: center;
				gap: 16px;
			}

			.illustration {
				height: 94px;
				margin-right: -3px;
				background-color: var(--color-sand);
			}

			.illustration > svg {
				height: 100%;
				width: 100%;
			}
		`,
	];

	@property({ type: String }) gameName = "";
	@property({ type: Object }) barChart: TemplateResult | null = null;

	render() {
		return html`
			<div class="container">
				<div class="container-top">
					<div class="score-text-container">
						<h2 class="points-text">POINTS</h2>
					</div>
					<div class="game-name-container">
						<h2 class="game-name-text">${this.gameName}</h2>
					</div>
					<div class="illustration">
						${fistSvg}
					</div>
				</div>
				<div class="divider"></div>
				<div class="container-bottom">
					${this.barChart ?? html`<div>No chart available</div>`}
				</div>
			</div>
		`;
	}
}

export default GamePointsComponent;
